<div class="gw-w-full gw-relative">
  <label
    *ngIf="label"
    class="gw-font-bold gw-text-text-primary gw-mb-[12px] gw-block"
  >
    {{ label }}
  </label>

  <!-- Upload area: shown when no preview and not uploading -->
  <div
    *ngIf="!uploading && !previewUrl"
    class="gw-border-base gw-mt-small gw-bg-background-elevation-1 gw-p-x-small gw-flex gw-items-center gw-justify-between gw-gap-3"
  >
    <div class="gw-flex gw-items-center gw-gap-3 gw-w-full">
      <gatewee-icon
        icon="@tui.image"
        iconStyle="primary"
        size="38px"
      ></gatewee-icon>
      <div>
        <p class="gw-font-bold gw-text-text-primary gw-m-0">
          Escolha um arquivo
        </p>
        <p class="gw-text-text-secondary gw-text-[12px] gw-m-0">
          {{ acceptAttr }}
        </p>
      </div>
    </div>

    <label
      class="gw-cursor-pointer gw-flex gw-items-center gw-border-base gw-p-2"
      title="Selecionar arquivo"
    >
      <input
        #fileInput
        type="file"
        [accept]="acceptAttr"
        class="gw-hidden"
        (click)="fileInput.value = ''"
        (change)="onFileChange($any($event.target).files?.[0] ?? null, fileInput)"
      />
      <gatewee-icon
        icon="@tui.upload"
        iconStyle="primary"
        size="18px"
      ></gatewee-icon>
    </label>
  </div>

  <!-- Uploading state -->
  <div
    *ngIf="uploading"
    class="gw-border-base gw-mt-small gw-bg-background-elevation-1 gw-p-x-small gw-flex gw-items-center gw-gap-3"
  >
    <gatewee-icon
      icon="@tui.loader"
      iconStyle="primary"
      size="24px"
    ></gatewee-icon>
    <p class="gw-text-text-secondary gw-text-[12px] gw-m-0">
      Fazendo upload...
    </p>
  </div>

  <!-- Preview: shown when there is a URL and not uploading -->
  <div *ngIf="!uploading && previewUrl" class="gw-mt-3">
    <img
      [src]="previewUrl"
      alt="Preview"
      class="gw-rounded-xl gw-border-base gw-w-[60px] gw-h-[60px] gw-object-cover"
    />

    <div class="gw-mt-2 gw-flex gw-items-center gw-gap-3">
      <label
        class="gw-inline-flex gw-items-center gw-gap-1 gw-cursor-pointer gw-text-text-secondary gw-text-[12px]"
        title="Trocar imagem"
      >
        <input
          #fileInput2
          type="file"
          [accept]="acceptAttr"
          class="gw-hidden"
          (click)="fileInput2.value = ''"
          (change)="onFileChange($any($event.target).files?.[0] ?? null, fileInput2)"
        />
        <gatewee-icon icon="@tui.refresh-cw" size="12px"></gatewee-icon>
        Trocar
      </label>

      <button
        type="button"
        class="gw-inline-flex gw-items-center gw-gap-1 gw-text-[12px] gw-text-status-negative gw-bg-transparent gw-border-none gw-cursor-pointer gw-p-0"
        (click)="clearImage()"
      >
        <gatewee-icon
          icon="@tui.x"
          size="12px"
          iconStyle="negative"
        ></gatewee-icon>
        Remover
      </button>
    </div>
  </div>

  <!-- Error message -->
  <p *ngIf="errorMsg" class="gw-mt-2 gw-text-[12px] gw-text-status-negative">
    {{ errorMsg }}
  </p>
</div>

<!-- Cropper dialog template -->
<ng-template #cropperDialogTpl let-close>
  <div class="gw-p-4">
    <image-cropper
      [imageFile]="cropperImageFile"
      [maintainAspectRatio]="true"
      [aspectRatio]="aspectRatio ?? 1"
      [resizeToWidth]="resizeToWidth ?? 0"
      [resizeToHeight]="resizeToHeight ?? 0"
      format="png"
      output="blob"
      (imageCropped)="onImageCropped($event)"
    ></image-cropper>
  </div>

  <div class="gw-flex gw-justify-end gw-gap-3 gw-px-4 gw-pb-4">
    <gatewee-button
      variant="outline"
      title="Cancelar"
      (clicked)="cancelCrop(close)"
    ></gatewee-button>
    <gatewee-button
      variant="primary"
      title="Recortar e usar"
      [disabled]="!croppedBlob"
      (clicked)="confirmCrop(close)"
    ></gatewee-button>
  </div>
</ng-template>
